module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "songList"
  }, [_c('ul', {
    staticClass: "songListUl"
  }, _vm._l((_vm.songList), function(item, index) {
    return _c('li', {
      class: {
        'current': _vm.iscurrent == index
      },
      on: {
        "click": function($event) {
          return _vm.play(index)
        }
      }
    }, [_c('span', {
      staticClass: "rankIndex",
      class: {
        'good': index < 3, 'first': index == 0, 'second': index == 1, 'third': index == 2
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.title))])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6590385a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/rankSongList.vue
// module id = 102
// module chunks = 0